import { types, async } from "../utils/type-creator";

export default types(
  ["SNACKBAR_SUCCESS", "SNACKBAR_CLEAR", "SNACKBAR_ERROR"],
  "COMMON"
);
